import config from '../../config';

export const onSm = `@media ${config.responsiveBreakpoints.sm}`;

export const onMd = `@media ${config.responsiveBreakpoints.md}`;

export const onLg = `@media ${config.responsiveBreakpoints.lg}`;

export const onXlg = `@media ${config.responsiveBreakpoints.xlg}`;

export const onXxlg = `@media ${config.responsiveBreakpoints.xxlg}`;
